import * as React from 'react';

import {CHANNEL_UNKNOWN} from 'nutshell-core/channels/consts';

import type {ChannelType} from 'nutshell-graphql-types';

import type {SourceValues} from '../types';

import {SourceModalContent} from './source-modal-content';

type Props = {
    onClose: () => void;
    onUpdateSource: (id: string, name: string, channel?: ChannelType | null | undefined) => any;
    isSaving: boolean;
    initialValues?: SourceValues;
};

export function EditSourceModal(props: Props) {
    return (
        <SourceModalContent
            onClose={props.onClose}
            onSubmit={(name: string, channel?: ChannelType | null, id?: string) => {
                if (!id) return;

                // No channel needs to be `CHANNEL_UNKNOWN` not `null`
                props.onUpdateSource(id, name, channel ? channel : CHANNEL_UNKNOWN);
            }}
            title='Edit source'
            buttonText='Update source'
            isSaving={props.isSaving}
            initialValues={props.initialValues}
        />
    );
}
